import { appInstallTopBannerState, getAppInstallTopBannerState, hideBanner } from '@/recoil/atoms/cuj/index';
import { Client, ClientType } from '@/types/app';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useRecoilValue } from 'recoil';
dayjs.extend(isSameOrAfter);

const useAppInstallTopBanner = () => {
  const { isVisible } = useRecoilValue(appInstallTopBannerState);

  useEffect(() => {
    getAppInstallTopBannerState();
  }, []);

  // 스크롤 기반 가시성 상태
  const [isScrollVisible, setIsScrollVisible] = useState(true);
  const lastScrollYRef = useRef(0);
  const rafIdRef = useRef<number | null>(null);

  // 스크롤 이벤트 핸들러 (RAF 최적화)
  useEffect(() => {
    const threshold = 300;

    const handleScroll = () => {
      // RAF가 이미 예약되어 있으면 중복 실행 방지
      if (rafIdRef.current !== null) {
        return;
      }

      rafIdRef.current = requestAnimationFrame(() => {
        const currentScrollY = window.scrollY;
        const lastScrollY = lastScrollYRef.current;

        // threshold 이하에서는 항상 표시
        if (currentScrollY < threshold) {
          setIsScrollVisible(true);
        } else {
          // 위로 스크롤: 표시, 아래로 스크롤: 숨김
          if (currentScrollY < lastScrollY) {
            setIsScrollVisible(true);
          } else if (currentScrollY > lastScrollY) {
            setIsScrollVisible(false);
          }
        }

        lastScrollYRef.current = currentScrollY;
        rafIdRef.current = null;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafIdRef.current !== null) {
        cancelAnimationFrame(rafIdRef.current);
      }
    };
  }, []);

  const isNewAdVisible = useMemo(() => {
    const targetDate = dayjs('2025-11-12T00:00:00');
    const now = dayjs();
    return now.isSameOrAfter(targetDate, 'day');
  }, []);

  const isNewAdVisibleClient = (client: Client) => {
    const visibleClientTypes = [ClientType.MOBILE_WEB];

    return visibleClientTypes.includes(client.clientType);
  };

  return {
    isVisible,
    isNewAdVisible,
    isNewAdVisibleClient,
    isScrollVisible,
    hideBanner,
  };
};

export default useAppInstallTopBanner;
